var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33.079.584C15.463.584 1.163 14.884 1.163 32.5c0 17.617 14.3 31.917 31.916 31.917s31.916-14.3 31.916-31.917c0-17.616-14.3-31.916-31.916-31.916zm0 58.436c-14.625 0-26.52-11.895-26.52-26.52S18.453 5.979 33.078 5.979s26.52 11.896 26.52 26.52c0 14.626-11.895 26.521-26.52 26.521z","fill":"#fff","key":0}),React.createElement("path",{"d":"M27.554 43.484c.39.195.78.259 1.17.259.455 0 .975-.13 1.366-.455l13.13-8.97a2.494 2.494 0 001.04-2.017c0-.779-.39-1.559-1.104-2.016L30.024 21.58c-.78-.52-1.69-.52-2.534-.13-.78.455-1.3 1.234-1.3 2.146v17.68c.064.974.518 1.82 1.364 2.208z","fill":"#fff","key":1})]);
}

Play.defaultProps = {"width":"66","height":"66","viewBox":"0 0 66 66","fill":"none"};

module.exports = Play;

Play.default = Play;
